import React from "react"

const Checkmark = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="10"
    viewBox="0 0 16 10"
  >
    <path
      fill="none"
      fillRule="evenodd"
      stroke="#FFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 0L5.375 10 1 5.455"
    />
  </svg>
)

export { Checkmark as default }



// WEBPACK FOOTER //
// ./assets/common/components/Checkmark.js